/* FBP search-insights loader.
 *
 * This file is served by SHOPIFY's CDN, so it is always fast and always available. It then
 * lazily fetches the actual insights script from the droplet AFTER window load, with a 5s
 * timeout.
 *
 * Why it exists: theme.liquid used to carry
 *   <script src="https://chat.furrybodypillows.com/live-search-insights.js" defer>
 * Deferred scripts execute BEFORE DOMContentLoaded, so if the droplet hung (rather than
 * refusing outright) every storefront page's interactive JavaScript sat waiting on the network
 * timeout. Analytics must never be able to do that to the shop.
 *
 * Keeping it here rather than inline in theme.liquid also matters practically: theme.liquid is
 * within about a kilobyte of Shopify's 256 KB hard limit per template, and an inline version
 * pushed it over and made the file undeployable.
 */
(function () {
  var SRC = 'https://chat.furrybodypillows.com/live-search-insights.js?v=2026-04-04T03:15:00Z';
  var TIMEOUT_MS = 5000;

  function load() {
    // The new search ships its matching analytics locally; never run the legacy DOM counter against it.
    if (document.querySelector('[data-fbp-search]')) return;
    var s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    var timer = window.setTimeout(function () {
      // Give up quietly. Insights are optional; the shop is not.
      if (s.parentNode) s.parentNode.removeChild(s);
    }, TIMEOUT_MS);
    s.onload = s.onerror = function () { window.clearTimeout(timer); };
    (document.body || document.head).appendChild(s);
  }

  if (document.readyState === 'complete') load();
  else window.addEventListener('load', load, { once: true });
})();
